{
  "Teilflaeche": "Surface"
}
